import { render, staticRenderFns } from "./AktReview.vue?vue&type=template&id=ffa3949e"
import script from "./AktReview.vue?vue&type=script&lang=ts"
export * from "./AktReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports